export default __webpack_public_path__ + "static/media/hht2_ep_06.87688c77.png";